export * from './share-product-action';
